module.exports = __webpack_public_path__ + "static/img/6-10.ee89fe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/newsDetail/6-10.png
// module id = Sf5T
// module chunks = 1